class TabComponent extends HTMLElement {
  connectedCallback() {
    const scope = this
    const tabs = this.querySelectorAll('[role="tab"]')
    if (tabs.length) {
      tabs.forEach((tab) => {
        tab.addEventListener("click", (event) => {
          const targetBase = event.target.htmlFor
          const oldTab = scope.querySelector('label[aria-selected="true"]')
          oldTab.setAttribute("aria-selected", "false")
          event.target.ariaSelected = true

          const oldContent = scope.querySelector(
            'section[role="tabpanel"][aria-hidden="false"]'
          )
          oldContent.setAttribute("aria-hidden", "true")
          const newContent = scope.querySelector(`#${targetBase}-content`)
          newContent.setAttribute("aria-hidden", "false")
        })
      })
    }
  }
  disconnectedCallback() {
    const tabs = this.querySelectorAll('[role="tab"]')
    if (tabs.length) {
      tabs.forEach((tab) => {
        tab.removeEventListener("click", () => false)
      })
    }
  }
}
customElements.define("tab-component", TabComponent)
